import React, { useContext, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import AuthContext from 'common/auth';
import UiContext from 'common/UiContext/UiContext';

const OtpLogin = ({ close }: { close(): void }) => {
  const {
    loginOTP,
    isOTPLoggingIn,
    otpError,
    otpErrorDetail,
    otpSuccessful,
  } = useContext(AuthContext)!;
  const { addToast } = useContext(UiContext);

  const formMethods = useForm({ mode: 'onChange' });
  const { handleSubmit, register, formState: { isSubmitting, isValid, isDirty } } = formMethods;

  const onSubmit = ({ token }: Record<string, string>) => {
    loginOTP(token);
  };

  useEffect(() => {
    if(otpError && otpErrorDetail) {
      Object.entries(otpErrorDetail).forEach(([, error]) => {
          addToast!(error, 'Error');
      });
    }
  }, [otpError, otpErrorDetail]);

  useEffect(() => {
    if(otpSuccessful) {
      close();
    }
  }, [otpSuccessful]);

  const formDisabled = isOTPLoggingIn || isSubmitting || (!isValid && isDirty);

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <label>
          <p>Enter the one-time password generated by your OTP app</p>
          <input
            type='text'
            placeholder='######'
            {...register('token', {
              minLength: {
                message: 'Token must be exactly 6 characters long',
                value: 6,
              },
              maxLength: {
                message: 'Token must be exactly 6 characters long',
                value: 6,
              },
              required: 'Token can\'t be blank',
            })}
          />
        </label>


        <button className='secondary big' onClick={() => close()}>Cancel</button>
        <button type='submit' className='primary big' disabled={formDisabled}>Verify</button>
      </form>
    </FormProvider>
  );
};

export default OtpLogin;